import { AfterViewInit, Component, OnInit, ViewContainerRef } from '@angular/core';
import { bind1 } from '@angular/core/src/render3/instructions';
import { NgForm } from '@angular/forms';
import { DISABLED } from '@angular/forms/src/model';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { IMyDpOptions } from 'mydatepicker';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { debug } from 'util';
import { Entity } from '../Classes/EntityClass';
import { ConfirmDialogService } from '../confirm-dialog/confirm-dialog.service';
import { EntityService } from '../Services/EntityService';
import { OrganizationService } from '../Services/OrganizationService';
import { SubscriptionService } from '../Services/SubscriptionService';


@Component({
  selector: 'Create-Entity',
  templateUrl: '../Entity/CreateEntity.component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/jquery.dropdownReplacement.css', '../../Content/css/fixedheader.css',
    '../../Content/css/jquery.dropdownReplacementhotel.css'],
  providers: [OrganizationService, EntityService, SubscriptionService]
})

export class CreateEntityComponent implements OnInit, AfterViewInit {
  Title: string = "";
  _Entity = new Entity();
  _State: boolean = false;
  _PMSMaster: boolean = false;
  _Status: boolean = false;
  _PMS_Setting: string = '1';
  _PMSSetting: boolean = false;
  _RFT: boolean = false;
  Alert: boolean = true;
  //OnlyCheck: boolean =true;
  _AccExec: boolean = false;
  isValidFormSubmitted = false;
  isValidFormAddAppSubmitted = false;
  ClientEditApp: any = [];
  isValidFormFranchise = false;
  isValidFormHotel = false;
  CurrentAppName: string;
  Buttontext: string;
  ModelAddBrand: string = "none";
  ModelEditBrand: string = "none";
  ModelAddApp: string = "none";
  BrandCheck: string = "none";
  modelHotal: string = "none";
  modelTerminationDate: string = "none";
  ParentPage: string = "";
  EditHotelDet: string = "";
  checkAppStatus1: string = "";
  checkAppStatus2: string = "";
  checkAppStatus3: string = "";
  checkAppStatus4: string = "";
  checkAppStatus5: string = "";
  checkAppStatus6: string = "";
  checkAppStatus7: string = "";
  EditFranchiseDet: string = "";
  prevTimeZone: string = "-1";
  AllState: any;
  AllPMSSettingState: any;
  AllPMS_Setting: any;
  AllPMS_SettingType: any;



  _IsValid: boolean = true;
  RoleID: string = "";
  Mode: string = "";
  innerWidth: number;
  //SelectHotel: string='';
  //SelectFranchise: boolean;
  Sethotelheight: number;
  SetAppheight: number;
  loading: boolean = false;
  QueryAppType: string;
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  AllAccExecutive: any[]
  QueryTenantID: any = [];
  QueryEntityID: any = [];
  QueryOrgcode: any = [];
  SearchResult: any = [];
  FranchiseDropDown: any = [];
  HotelDropDown: any = [];
  EPayGrid: any = [];
  QueryAppValue: string;
  QueryBrandValue: string;
  OrgCode: string;
  CheckAppExt: string;
  CheckAppExt1: string = "0";
  CheckAppExt2: string = "0";
  CheckAppExt3: string = "0";
  CheckAppExt4: string = "0";
  CheckAppExt5: string = "0";
  CheckAppExt6: string = "0";
  CheckAppExt7: string = "0";
  CheckHotelExt: string = "0";
  CheckApptype: string;
  OrgStartDate: any;
  btnfranchise: boolean = false;
  TenantStatus = 'Active'
  EntityStaus = 'Active'
  ConfirmEntity: string = 'none';
  //_OnlyCheck: boolean = false;
  modelChangeLog: string = "none";
  EntityChangeLog: any = [];
  SubsMaxDate: string;
  SubsStatus: string;
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    height: '20px',
    width: '95%',
    selectionTxtFontSize: '12px',
    inline: false,
    //markDates: [color: 'green'],
    selectorHeight: '218px',
    selectorWidth: '247px',
    openSelectorOnInputClick: true,
    editableDateField: false
  };
  public myDatePickermonthOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'mmm yyyy',
    height: '20px',
    width: '95%',
    selectionTxtFontSize: '12px',
    inline: false,
    //markDates: [color: 'green'],
    selectorHeight: '218px',
    selectorWidth: '247px',
    openSelectorOnInputClick: true,
    editableDateField: false
  };
  constructor(private router: Router, private http: Http, public toastr: ToastsManager, vcr: ViewContainerRef,
    private _OrganizationSer: OrganizationService,
    private Activeroute: ActivatedRoute, private _EntityService: EntityService, private _Subscription: SubscriptionService, private confirmDialogService: ConfirmDialogService) {
    this.toastr.setRootViewContainerRef(vcr);
    this.innerWidth = 100;
    this.Sethotelheight = 122;
    this.SetAppheight = 100;
    window.scrollTo(0, 0);
  }
  ngOnInit() {

    if (this.Activeroute.snapshot.params['TenantID'] != null && this.Activeroute.snapshot.params['EntityID'] != null) {
      var TenantID = this.Activeroute.snapshot.params['TenantID'];
      var EntityID = this.Activeroute.snapshot.params['EntityID'];
      this.Mode = 'Edit';
      this.ParentPage = JSON.parse(atob(this.Activeroute.snapshot.params['pageName']));
      this.QueryTenantID = JSON.parse(atob(TenantID));
      this.QueryEntityID = JSON.parse(atob(EntityID)).toString();
      this.OrgCode = this.Activeroute.snapshot.params['OrgCode'];
      this.QueryOrgcode = JSON.parse(atob(this.OrgCode));
      this.getallstate();
      this.getallPMSMaster();


      this.getAllPMSSetting();
      this.getalluser();
     
      this.Setheight();
      this.GetTableData();
      this._Entity.FranchiseDD = '-1';
      this._Entity.PMS_SystemId = "-1";
      this.GetFranchiseDD();
      this.GetHotelcompleteData();
      this.GetHotelAccountcompleteData();
      this.GetEntityDetails();
      this.Alert = false;
      //this._Entity.DigitalACS = "Disabled";
      // this._OnlyCheck = false;
      this._State = true;
      this._PMSMaster = true;
      // this._PMSSetting = true;
      this._Status = true;
      this._RFT = true;
      //this._Entity.EntityStatus = "-1";
      //this._Entity.TimeZone = "EST";
      this.RoleID = sessionStorage.getItem('RoleID');
      //if (this._Entity.ReasonForTermination == "") {
      //  this._Entity.ReasonForTermination = "-1";
      //}
      //else {
      //  this._Entity.ReasonForTermination = "-1";
      //}
      localStorage.setItem("TenantID", this.QueryTenantID);
    }
    else if (localStorage.getItem('HotelId') != null && localStorage.getItem('HotelId') != '') {
      var ParamTenantID = localStorage.getItem('TenantID');
      var ParamHotelId = localStorage.getItem('HotelId');
      if (ParamTenantID != "null" && ParamTenantID != null && ParamHotelId != null && ParamTenantID != "null") {

        this.QueryTenantID = ParamTenantID;
        this.QueryEntityID = ParamHotelId.toString();
        this.QueryOrgcode = localStorage.getItem('OrgCode');
        this.getallstate();
        this.getallPMSMaster();
        this.getAllPMSSetting();
        this.getalluser();

        this.Setheight();
        this.GetTableData();
        this._Entity.FranchiseDD = '-1';
        this._Entity.PMS_SystemId = "-1";
        this.GetFranchiseDD();
        this.GetHotelcompleteData();
        this.GetEntityDetails();
        this.Alert = false;
        //  this._OnlyCheck = false;
        this._State = true;
        this._PMSMaster = true;
        this._Status = true;
        this._RFT = true;
        //this._Entity.EntityStatus = "-1";
        // this._Entity.TimeZone = "EST";
        this.RoleID = sessionStorage.getItem('RoleID');
        //if (this._Entity.ReasonForTermination == "") {
        //  this._Entity.ReasonForTermination = "-1";
        //}
        //else {
        //  this._Entity.ReasonForTermination = "-1";
        //}
        localStorage.setItem("TenantID", this.QueryTenantID);
      }
    }
    else {
      this.Title = "Create Entity";
      var TenantId = localStorage.getItem('TenantID');
      if (TenantID == null || TenantID == undefined) {
        TenantID = this.Activeroute.snapshot.params['TenantID'];
        this.QueryTenantID = JSON.parse(atob(TenantID));

      }
      else {
        this.QueryTenantID = TenantId;
      }
      this._Entity.TenantId = this.QueryTenantID;
      this.OrgCode = localStorage.getItem('OrgCode');
      this.QueryOrgcode = this.OrgCode;
      if (this.OrgCode == null || this.OrgCode == undefined) {
        this.OrgCode = this.Activeroute.snapshot.params['OrgCode'];
        this.QueryOrgcode = JSON.parse(atob(this.OrgCode));
      }
      this.Mode = 'New';
      this._Entity.TimeZone = "EST";
      this._Entity.OrganizationCode = this.QueryOrgcode;
      localStorage.setItem("TenantID", this.QueryTenantID);

      this._Entity.FranchiseDD = '-1';
      this.GetFranchiseDD();
      this.getallstate();
      this.getallPMSMaster();
      this.getalluser();


      this.getAllPMSSetting();

      this.Setheight();
      //this.openHotel(this.showExtender);
      this._Entity.Type = "-1";
      this._Entity.OverTime = "1.5";
      this._Entity.Status = "Active";
      this._Status = true;
      this._Entity.AccountExecutive = "-1";
      this._Entity.DoubleEntrySystem = "Single";
      this._Entity.HolidayRate = "1.5";
      this._Entity.DoubleOverTime = "2.0";
      this._Entity.BillingFrequency = "Monthly"
      this._Entity.DigitalACS = "Disabled";
      this._Entity.state = "-1";
      this._Entity.pmsMaster = "-1";
      this._Entity.PMS_SystemId = "-1";
      this._Entity.DoubleEntrySystemEntry = "Single";
      this._Entity.EPaySetting = false;
    }

    this.ChangeHeadeFooterColor();
  }

  ngAfterViewInit() {
    this.GetEntitychangeLog();
    // this.getAllPMSSetting();
  }

  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }

  CloseCreateEnity() {

    this.ParentPage = JSON.parse(atob(this.Activeroute.snapshot.params['pageName']));
    if (this.ParentPage == "Subscription") {
      this.router.navigate(['/Subscription']);
    } else if (this.ParentPage == "EntitySearch") {
      this.router.navigate(['/Entity']);
    }
    else if (this.ParentPage == "SubscriptionDetails") {
      var EntityID = localStorage.getItem('EntityID');
      var OrganizationCode = localStorage.getItem('OrganizationCode');
      var entityCode = localStorage.getItem('entityCode');
      var module = localStorage.getItem('module');

      this.router.navigate(['/SubscriptionDetails', {
        TenantID: btoa(JSON.stringify(this.QueryTenantID)),
        OrganizationCode: btoa(JSON.stringify(OrganizationCode)),
        EntityID: btoa(JSON.stringify(EntityID)),
        Module: btoa(JSON.stringify(module)),
        EntityCode: btoa(JSON.stringify(entityCode)),
        pageName: btoa(JSON.stringify('SubscriptionDetails'))
      }]);
    }
    else {
      localStorage.setItem('HotelId', '');
      //localStorage.setItem('TenantID', 'null');
      this.router.navigate(['/OrganizationDetails', {
        pageName: btoa(JSON.stringify('CreateEntity'))
      }]);
    }
  }




  public getallstate() {
    this._OrganizationSer.GetState().subscribe(res => {
      this.AllState = res;
    })
  }

  public getallPMSMaster() {
    this._OrganizationSer.GetPMSMaster().subscribe(res => {
      this.AllPMSSettingState = res;
      //console.log(res);
      //console.log("PMS");
    })
  }


  public getAllPMSSetting() {
    this._EntityService.GetPMSSetting(this._PMS_Setting).subscribe(res => {
      this.AllPMS_Setting = res;
    })

  }

  public getAllEntryTypeByPMSSetting(data) {

    this._EntityService.GetEntryTypBYPmsSetting(data).subscribe(res => {
      this.AllPMS_SettingType = res;
      this._Entity.DoubleEntrySystem = this.AllPMS_SettingType[0].entryType;
    })
  }


  public strimdata(val: string) {
    if (val != undefined) {
      return val.trim();
    }
  }

  public Keypress(event: any) {
    const pattern = /^[a-zA-Z ]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  public KeypressBank(event: any) {
    const pattern = /^[a-zA-Z0-9 ]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  public keypresss(event: any) {
    const pattern = /[0-9\+\-\\]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public keyPress(event: any) {
    const pattern = /[0-9\+\-\.\\]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  OpenAddBrand(Name: string, value: string) {
    this.isValidFormFranchise = false;
    this.ModelAddBrand = "block";
    this._Entity.Queryname = Name;
    this.QueryBrandValue = value;
    this._Entity.AddBrand = null;
    this.btnfranchise = false;
  }


  openHotel(Name: string, value: string) {
    this.modelHotal = "block";
    this._Entity.Queryname = Name;
    this.QueryBrandValue = value;
    this.btnfranchise = false;
    this._Entity.HotelBrandOther = "";
    this.Sethotelheight = 122;
    this.Buttontext = "Save";
    this.GetFranchiseDD();
    this._Entity.FranchiseDD = "-1";
    if (this._Entity.FranchiseBrand != null) {
      if (this._Entity.FranchiseBrand != "")
        if (this._Entity.FranchiseBrand.Name != undefined) {
          this._Entity.FranchiseDD = this._Entity.FranchiseBrand.Name;
        }
        else {
          this._Entity.FranchiseDD = this._Entity.FranchiseBrand;
        }
      else {
        this._Entity.FranchiseDD = "-1";
      }
    }

    else {
      this._Entity.FranchiseDD = "-1";
    }
    //if (type == "false") {
    //  this.showExtender = false;
    //}
    //else {
    //  this.showExtender = true;
    //}
  }

  ShowAlert() {
    this.Alert = true;
    //   this._OnlyCheck = true;
  }

  public GetEntitychangeLog() {
    if (this.QueryEntityID.length != 0) {
      this._EntityService.GetEntitychangeLog(this.QueryEntityID).subscribe(res => {
        this.EntityChangeLog = res;
      });
    }
  }

  ShowLog() {
    this.modelChangeLog = "block";
  }

  CloseChangeLog() {
    this.modelChangeLog = "none";
  }

  OpenEditBrand(Name: string, value: string, text: any) {
    if (text.Name != undefined) {
      this._Entity.EditAddBrand = text.Name;
      this._Entity.AddBrandId = text.Id;
    }
    else {
      this._Entity.EditAddBrand = text;
    }

    this.ModelEditBrand = "block";
    this._Entity.Queryname = Name;
    this.QueryBrandValue = value;
    this.btnfranchise = false;
  }

  OpenAddApp(Type: string, Value: string) {

    this._Entity.AddApp = "";
    this.ModelAddApp = "block";
    this.SetAppheight = 120;
    this.QueryAppType = Type;
    if (Type == "1") { this.CurrentAppName = "PMS Used" }
    else if (Type == "2") { this.CurrentAppName = "Accounting" }
    else if (Type == "3") { this.CurrentAppName = "Labor Management" }
    else if (Type == "4") { this.CurrentAppName = "Payroll" }
    else if (Type == "5") { this.CurrentAppName = "Procurement" }
    else if (Type == "6") { this.CurrentAppName = "Sales" }
    else if (Type == "7") { this.CurrentAppName = "Facilities Management" }

    this.QueryAppValue = Value;
    this._Entity.AddAppId = "0";
    // = this._Entity.DoubleEntrySystemEntry;
    // this. = this._Entity.DoubleEntrySystemEntry;
    this.isValidFormAddAppSubmitted = false;
    if (Type == "1" && Value == "New") {
      this._Entity.DoubleEntrySystemEntry = "Single";
    }

  }

  EditAddApp(Type: string, Name: any, Value: string) {

    this.ModelAddApp = "block";
    this.QueryAppType = Type;
    this.SetAppheight = 320;
    this.checkAppStatus1 = "";
    this.checkAppStatus2 = "";
    this.checkAppStatus3 = "";
    this.checkAppStatus4 = "";
    this.checkAppStatus5 = "";
    this.checkAppStatus6 = "";
    this.checkAppStatus7 = "";
    if (Type == "1") {

      this.CurrentAppName = "PMS Used"
      this._Entity.AddAppId = this._Entity.PMS_SystemId;

      this._EntityService.GetEntryTypBYPmsSetting(Name).subscribe(res => {
        this.AllPMS_SettingType = res;
        if (this.AllPMS_SettingType.length != 0) {
          this._Entity.DoubleEntrySystemEntry = this.AllPMS_SettingType[0].entryType;
          if (this._Entity.AddAppId == "-1") {

            this._Entity.AddAppId = this.AllPMS_SettingType[0].id;
          }
        } else {
          this._Entity.DoubleEntrySystemEntry = "Single";
        }
      })

      this.getEditClientAppData(Type);
    }
    else if (Type == "2") {
      this.CurrentAppName = "Accounting";
      this._Entity.AddAppId = this._Entity.AccountingId;
      this.getEditClientAppData(Type);
    }
    else if (Type == "3") {
      this.CurrentAppName = "Labor Management"
      this._Entity.AddAppId = this._Entity.Labour_ManagementId;
      this.getEditClientAppData(Type);
    }
    else if (Type == "4") {
      this.CurrentAppName = "Payroll"
      this._Entity.AddAppId = this._Entity.PayrollId;
      this.getEditClientAppData(Type);
    }
    else if (Type == "5") {
      this.CurrentAppName = "Procurement"
      this._Entity.AddAppId = this._Entity.ProcurementId;
      this.getEditClientAppData(Type);
    }
    else if (Type == "6") {
      this.CurrentAppName = "Sales"
      this._Entity.AddAppId = this._Entity.SalesId;
      this.getEditClientAppData(Type);
    }
    else if (Type == "7") {
      this.CurrentAppName = "Facilities Management"
      this._Entity.AddAppId = this._Entity.Facilities_ManagementId;
      this.getEditClientAppData(Type);
    }
    this.QueryAppValue = Value;
    this._Entity.AddApp = Name;
    if (this._Entity.AddAppId == null || this._Entity.AddAppId == "") {
      this._Entity.AddAppId = Name.id;
    }
    //this.isValidFormAddAppSubmitted = true;
  }

  FillVendor() {
  }

  FranchiseChange() {
    this._Entity.HotelBrand = "";
  }

  SetFranchiseBrand() {
    if (this._Entity.FranchiseBrand == "" || this._Entity.FranchiseBrand == null) {
      var franchiseId = this._Entity.HotelBrand.Uniqueno;
      if (franchiseId != null) {
        this._EntityService.GetSetFranchisebyHotelBrand(franchiseId, this._Entity.TenantId.toString()).subscribe(res => {
          if (res != null) {
            this._Entity.FranchiseBrand = res.Name;
            //new change this._Entity.FranchiseBrandID = res.FranchiseId;
            this._Entity.FranchiseGroupID = res.FranchiseId;
            //this._Entity.AddBrandId = res.FranchiseId;
            this._Entity.Intersectid = res.IntersectId;
            this._Entity.HotelGroupID = res.HotelGroupId;
          }
        });
      }
    }
  }

  RefreshControl() {
    this._Entity.state = "-1";
    this._Entity.Province = "";

  }

  RefreshEpay() {

  }

  RefreshDoubleEntry() {
    //this._Entity.DualPMSSetting = false;
    //this._Entity.isDualPMS = "0";
    //this._Entity.pmsMaster = null;
  }

  RefreshOthers() {
    this._Entity.BankRoutingNumber = "";
    this._Entity.Bankname = "";
    this._Entity.BankAccNumber = "";
    this._Entity.CCtype = "";
    this._Entity.CCNumber = "";
    this._Entity.CCName = "";
    this._Entity.ExpirationDate = new Date();
  }

  public getalluser() {
    this._EntityService.GetAccExecutivesForEntity(this.Mode, this.QueryTenantID, this.QueryEntityID).subscribe(res => {
      this.AllAccExecutive = res;
    })

  }



  public getClientAppData = (type: any, SearchStr: any): Observable<any[]> => {

    if (SearchStr) {
      this._Entity.SearchtextFirst = SearchStr;
      let EntityDetails = { "mQuery": JSON.stringify(SearchStr), "Type": JSON.stringify(type) };
      let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
      let options: RequestOptions = new RequestOptions({ headers: headers, params: EntityDetails });
      return this.http.get('api/Entity/getClientAppData', options)
        .map(res => {
          let json = res.json();
          let jsonarray = json;
          return jsonarray;
        })
    }
    else {
      return Observable.of([]);
    }
  }

  public getEditClientAppData(type: any) {
    let EntityDetails = { "Type": JSON.stringify(type) };
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers, params: EntityDetails });
    return this.http.get('api/Entity/getEditClientAppData', options)
      .map((res: Response) => res.json()).subscribe(res => {
        this.ClientEditApp = res;
        //console.log(this.ClientEditApp);
      });
  }
  public GetHotelBrand = (SearchStr: any): Observable<any[]> => {
    if (SearchStr) {
      if (this._Entity.FranchiseBrand.Name != undefined) {
        this._Entity.FranchiseBrand = this._Entity.FranchiseBrand.Name;
      }
      else {
        this._Entity.FranchiseBrand = this._Entity.FranchiseBrand;
      }
      let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
      let ParmDetails = { "mQuery": JSON.stringify(SearchStr), "TenantId": JSON.stringify(this.QueryTenantID), "FranchiseName": JSON.stringify(this._Entity.FranchiseBrand), "HotelId": JSON.stringify(this._Entity.EntityID) };
      let options: RequestOptions = new RequestOptions({ headers: headers, params: ParmDetails });
      return this.http.get('api/Entity/getHotelDD', options)
        .map(res => {
          let result = res.json();
          return result;
        });
    }
    else {
      return Observable.of([]);
    }
  }

  public GetHotelBrandDD = (SearchStr: any): Observable<any[]> => {
    if (SearchStr) {
      if (this._Entity.FranchiseBrand != null && this._Entity.FranchiseBrand != "") {
        this._Entity.FranchiseBrand = this._Entity.FranchiseBrand.Name;
      }
      else if (this._Entity.FranchiseBrand == null) {
        this._Entity.FranchiseBrand = "";
      }
      else {
        this._Entity.FranchiseBrand = this._Entity.FranchiseBrand;
      }
      let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
      let ParmDetails = { "mQuery": JSON.stringify(SearchStr), "TenantId": JSON.stringify(this.QueryTenantID), "FranchiseName": JSON.stringify(this._Entity.FranchiseBrand) };
      let options: RequestOptions = new RequestOptions({ headers: headers, params: ParmDetails });
      return this.http.get('api/Entity/getHotelDD', options)
        .map(res => {
          let result = res.json();
          return result;
        });
    }
    else {
      return Observable.of([]);
    }
  }

  public EditOrganizationDetails(data: any) {
    this._Entity.EntityID = data.entityID;
  }

  public StateChange() {
    this._State = true;
    //this._State = true;
  }
  public PmsMasterChange() {
    this._PMSMaster = true;
  }
  public DualPmsChange() {
    //if (this._Entity.DualPMSSetting) {
    //  this._Subscription.GetDaautoImport(this.QueryTenantID, this.QueryEntityID).subscribe(res => {
    //    var data = res;
    //    if (data != null) {
    //      if (data[0].daAutoImport == "") {
    //        this.toastr.error("Please set-up primary PMS for the entity first.");
    //        this._Entity.DualPMSSetting = false;
    //        this.loading = false;
    //        return;
    //      }
    //    }
    //  });
    //}
  }

  public PMSSettingChage(ID: any) {

    this._PMSSetting = true;
    var data = this.AllPMS_Setting.filter(p => p.id == ID)[0].appName;
    this._Entity.PMS_System = data;
    this._Entity.PMS_SystemId = ID
    this.getAllEntryTypeByPMSSetting(this._Entity.PMS_System);
  }

  public AccExecutiveChange() {
    this._AccExec = true;
  }
  public GetFranchiseAutocomplete = (SearchStr: any): Observable<any[]> => {

    if (SearchStr) {
      let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
      let ParmDetails = { "mQuery": JSON.stringify(SearchStr), "TenantId": JSON.stringify(this.QueryTenantID) };
      let options: RequestOptions = new RequestOptions({ headers: headers, params: ParmDetails });
      return this.http.get('api/Entity/getFranchiseData', options)
        .map(res => {
          let result = res.json();
          return result;
        });
    }
    else {
      return Observable.of([]);
    }
  }

  public GetFranchiseDD() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let ParmDetails = { "mQuery": JSON.stringify(""), "TenantId": JSON.stringify(this.QueryTenantID) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: ParmDetails });
    return this.http.get('api/Entity/getFranchiseData', options)
      .map((res: Response) => res.json()).subscribe(res => {
        this.FranchiseDropDown = res;
      });
  }

  public GetHotelAutocomplete = (SearchStr: any): Observable<any[]> => {

    if (SearchStr) {
      let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
      let ParmDetails = { "mQuery": JSON.stringify(SearchStr), "TenantId": JSON.stringify(this.QueryTenantID) };
      let options: RequestOptions = new RequestOptions({ headers: headers, params: ParmDetails });
      return this.http.get('api/Entity/getHotelBrandData', options)
        .map(res => {
          let result = res.json();
          return result;
        });
    }
    else {
      return Observable.of([]);
    }
  }


  public GetHotelcompleteData() {

    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let ParmDetails = { "TenantId": JSON.stringify(this.QueryTenantID) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: ParmDetails });
    return this.http.get('api/Entity/getHotelCompleteData', options)
      .map((res: Response) => res.json()).subscribe(res => {
        this.HotelDropDown = res;
      });
  }

  public GetHotelAccountcompleteData() {
    this._Subscription.GetEPayAccount(this.QueryTenantID, this.QueryEntityID).subscribe(res => {
      var Counter = 0;
      var data = res;
      this.EPayGrid = data;
      //console.log(this.EPayGrid);
      for (let i = 0; i < this.EPayGrid.length; i++) {
        if (this.EPayGrid[i].ePayCustID.length > 0) {
          Counter = Counter + 1;
        }
      }
      //if (Counter > 0) {
      //  this._Entity.EPaySetting = true;
      //}
    });
  }

  public EpayChange() {
    //console.log(this.EPayGrid);
  }

  SetFranchise(text: any, Id: any) {
    if (text != null) {
      if (text.Name != undefined) {
        this._Entity.EditAddBrand = text.Name;

      }
      else {
        this._Entity.EditAddBrand = text;
      }
    }
    else {
      this._Entity.EditAddBrand = text;
    }
    if (this._Entity.AddBrandId != Id) {
      this.EditFranchiseDet = "0";
    }
    this._Entity.AddBrandId = Id;

  }



  SetClientAppName(type: string, text: any, Id: any) {

    if (text != null) {
      if (text.appName != undefined) {
        if (type == "1") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text.appName;
          this.QueryAppType = type;

          if (this._Entity.PMS_System != this._Entity.AddApp) {
            this.checkAppStatus1 = type;
          }
          else {
            this.checkAppStatus1 = "";
          }
        }
        else if (type == "2") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text.appName;
          this.QueryAppType = type;
          if (this._Entity.Accounting != this._Entity.AddApp) {
            this.checkAppStatus2 = type;
          }
          else {
            this.checkAppStatus2 = "";
          }
        }
        else if (type == "3") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text.appName;
          this.QueryAppType = type;
          if (this._Entity.Labour_Management != this._Entity.AddApp) {
            this.checkAppStatus3 = type;
          }
          else {
            this.checkAppStatus3 = "";
          }
        }
        else if (type == "4") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text.appName;
          this.QueryAppType = type;
          if (this._Entity.Payroll != this._Entity.AddApp) {
            this.checkAppStatus4 = type;
          }
          else {
            this.checkAppStatus4 = "";
          }
        }
        else if (type == "5") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text.appName;
          this.QueryAppType = type;
          if (this._Entity.Procurement != this._Entity.AddApp) {
            this.checkAppStatus5 = type;
          }
          else {
            this.checkAppStatus5 = "";
          }
        }
        else if (type == "6") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text.appName;
          this.QueryAppType = type;
          if (this._Entity.Sales != this._Entity.AddApp) {
            this.checkAppStatus6 = type;
          }
          else {
            this.checkAppStatus6 = "";
          }
        }
        else if (type == "7") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text.appName;
          this.QueryAppType = type;
          if (this._Entity.Facilities_Management != this._Entity.AddApp) {
            this.checkAppStatus7 = type;
          }
          else {
            this.checkAppStatus7 = "";
          }
        }
      }
      else {

        if (type == "1") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text;
          this.QueryAppType = type;

          this._EntityService.GetEntryTypBYPmsSetting(this._Entity.AddApp).subscribe(res => {
            this.AllPMS_SettingType = res;

            if (this.AllPMS_SettingType[0].entryType != null) {
              this._Entity.DoubleEntrySystemEntry = this.AllPMS_SettingType[0].entryType;
            } else {
              this._Entity.DoubleEntrySystemEntry = "Single";
            }
          })





          if (this._Entity.PMS_System != this._Entity.AddApp) {
            this.checkAppStatus1 = type;
          }
          else {
            this.checkAppStatus1 = "";
          }
        }
        else if (type == "2") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text;
          this.QueryAppType = type;
          if (this._Entity.Accounting != this._Entity.AddApp) {
            this.checkAppStatus2 = type;
          }
          else {
            this.checkAppStatus2 = "";
          }
        }
        else if (type == "3") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text;
          this.QueryAppType = type;
          if (this._Entity.Labour_Management != this._Entity.AddApp) {
            this.checkAppStatus3 = type;
          }
          else {
            this.checkAppStatus3 = "";
          }
        }
        else if (type == "4") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text;
          this.QueryAppType = type;
          if (this._Entity.Payroll != this._Entity.AddApp) {
            this.checkAppStatus4 = type;
          }
          else {
            this.checkAppStatus4 = "";
          }
        }
        else if (type == "5") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text;
          this.QueryAppType = type;
          if (this._Entity.Procurement != this._Entity.AddApp) {
            this.checkAppStatus5 = type;
          }
          else {
            this.checkAppStatus5 = "";
          }
        }
        else if (type == "6") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text;
          this.QueryAppType = type;
          if (this._Entity.Sales != this._Entity.AddApp) {
            this.checkAppStatus6 = type;
          }
          else {
            this.checkAppStatus6 = "";
          }
        }
        else if (type == "7") {
          this._Entity.AddAppId = Id;
          this._Entity.AddApp = text;
          this.QueryAppType = type;
          if (this._Entity.Facilities_Management != this._Entity.AddApp) {
            this.checkAppStatus7 = type;
          }
          else {
            this.checkAppStatus7 = "";
          }
        }
      }
    }
  }

  SetHotel(text: any, Id: any) {
    this._Entity.HotelBrandOther = text;

    this.btnfranchise = false;
    this._EntityService.GetSetFranchisebyHotelBrand(Id, this._Entity.TenantId.toString()).subscribe(res => {
      if (res != null) {
        this._Entity.FranchiseDD = res.Name;
        this._Entity.Intersectid = res.IntersectId;
        if (Id != this._Entity.HotelGroupID) {
          this.EditHotelDet = "0";
        }
      }
    });
    this._Entity.HotelGroupID = Id;
  }


  public ConfirmSave(form: NgForm) {

    if ((this._Entity.Status == "Inactive" && this._Entity.ReasonForTermination == "-1")) {
      this._IsValid = false;
    }
    else {
      this._IsValid = true;
    }

    if (this._Entity.NonUS != true) {
      this._Entity.NonUS = false;
    }

    if ((this._Entity.EntityID == "" || this._Entity.EntityID == undefined) && this._Entity.Status == "Inactive") {
      this.toastr.error("Entity can not terminate while created as new. ");
      this.loading = false;
      return;
    }
    if (form.valid && (this._Entity.Status != "-1" && this._Status != false) &&
      ((this._State != false && this._Entity.state != "-1") || (this._Entity.NonUS == true)) && (this._IsValid == true) &&
      (this._Entity.AccountExecutive != '-1') && (this.CheckAppExt1 != "" && this.CheckAppExt2 != "" && this.CheckAppExt3 != ""
        && this.CheckAppExt4 != "" && this.CheckAppExt5 != "" && this.CheckAppExt6 != "" && this.CheckAppExt7 != "")) {
      var IsConfirm = true;
      if (this._Entity.Status == "Inactive") {
        this.ConfirmEntity = 'block';
        //IsConfirm = confirm("Terminating this Entity will terminate all Subscriptions associated with it. Are you sure you want to proceed?");
      }
      else {
        this.SaveEntityConfirm(form);
      }
    }
    else {
      this.isValidFormSubmitted = true;
      this._State = true;
      this._PMSMaster = true;
      this._RFT = true;
      this._AccExec = true;
      //this.CheckAppExt = "false";
    }

  }

  CloseEntityConfirm() {
    this.ConfirmEntity = 'none';
  }

  SaveEntityConfirm(form: NgForm) {

    this.ConfirmEntity = 'none';
    if (this._Entity.DigitalACS == "Disabled") {

      this.confirmDialogService.confirmThis("Disable digital ACH for this entity?.", () => {
        //alert("Second yes Clicked");

        this.confirmDialogService.confirmThis("Are you sure?.", () => {
          //alert("Second yes Clicked");
          if (this.Alert == true) {
            if (confirm('Warning: Changing OverTime/Double OverTime/Holiday Rate will impact all employees. Please confirm with your HR Department before making this change.') == true) {

              this.SaveOrganizationDetails();
            }
          }
          else {
            this.SaveOrganizationDetails();
          }
        },
          () => {
            //alert("First NO clicked");
          })

      },
        () => {
          //alert("First NO clicked");
        }).bind(this)

    }
    else {
      if (this.Alert == true) {
        if (confirm('Warning: Changing OverTime/Double OverTime/Holiday Rate will impact all employees. Please confirm with your HR Department before making this change.') == true) {

          this.SaveOrganizationDetails();
        }
      }
      else {
        this.SaveOrganizationDetails();
      }
    }


  }







  public hasSpace(sentence) {
  return sentence.indexOf(" ") >= 0;
}



  public SaveOrganizationDetails() {

    this.loading = true;

    this._Entity.Username = sessionStorage.getItem('UserName');
    this._Entity.TenantId = this.QueryTenantID;

    if (this._Entity.PMS_System != null) {
      if (this._Entity.PMS_System.id != null || this._Entity.PMS_System.Id != undefined) {
        this._Entity.PMS_System = this._Entity.PMS_System.appName;
      }
      else {
        this._Entity.PMS_System = this._Entity.PMS_System;
        /*this._Entity.PMS_System;*/
      }
    }
    if (this._Entity.Accounting != null) {
      if (this._Entity.Accounting.id != null || this._Entity.Accounting.Id != undefined) {
        this._Entity.Accounting = this._Entity.Accounting.appName;
      }
      else {
        this._Entity.Accounting = this._Entity.Accounting
      }
    }
    if (this._Entity.Sales != null) {
      if (this._Entity.Sales.id != null || this._Entity.Sales.Id != undefined) {
        this._Entity.Sales = this._Entity.Sales.appName;
      }
      else {
        this._Entity.Sales = this._Entity.Sales;
      }
    }
    if (this._Entity.Labour_Management != null) {
      if (this._Entity.Labour_Management.id != null || this._Entity.Labour_Management.Id != undefined) {
        this._Entity.Labour_Management = this._Entity.Labour_Management.appName;
      }
      else {
        this._Entity.Labour_Management = this._Entity.Labour_Management;
      }
    }
    if (this._Entity.Payroll != null) {
      if (this._Entity.Payroll.id != null || this._Entity.Payroll.Id != undefined) {
        this._Entity.Payroll = this._Entity.Payroll.appName;
      }
      else {
        this._Entity.Payroll = this._Entity.Payroll;
      }
    }
    if (this._Entity.Procurement != null) {
      if (this._Entity.Procurement.id != null || this._Entity.Procurement.id != undefined) {
        this._Entity.Procurement = this._Entity.Procurement.appName;
      }
      else {
        this._Entity.Procurement = this._Entity.Procurement;
      }
    }
    if (this._Entity.Facilities_Management != null) {
      if (this._Entity.Facilities_Management.id != null || this._Entity.Facilities_Management.Id != undefined) {
        this._Entity.Facilities_Management = this._Entity.Facilities_Management.appName;
      }
      else {
        this._Entity.Facilities_Management = this._Entity.Facilities_Management;
      }
    }
    if (this._Entity.BillByCC == true) {
      if (!this._Entity.ExpirationDate.jsdate) {
        this._Entity.ExpirationDate = this._Entity.ExpirationDate;
      }
      else {
        this._Entity.ExpirationDate = formatDate(this._Entity.ExpirationDate.jsdate);
      }

    }
    else {
      this._Entity.BillByCC = false;
    }

    //if (this._Entity.ExpirationDate == "") {
    //  this._Entity.ExpirationDate = new Date();
    //}

    if (this._Entity.BillByCC == true) {
      // NW-81482: new Date().toLocaleString() formats "now" using the browser/OS
      // locale (e.g. day-first "25/9/2026, ..." on an en-IN/en-GB machine).
      // new Date() on that string is not guaranteed to parse it back correctly and
      // can yield an Invalid Date, which formatDate() then renders as the literal
      // string "NaN/NaN/NaN" - and since 'N' sorts after every digit character,
      // ANY valid "yyyy/mm/dd" expiration date string compares <= "NaN/NaN/NaN",
      // failing this check unconditionally regardless of how far in the future the
      // real date is. Match the existing, locale-safe TerminationDate pattern
      // just below (formatDate(new Date())) instead of round-tripping through a
      // locale string.
      if (this._Entity.ExpirationDate <= formatDate(new Date())) {
        this.toastr.error('CC Expiration Date should be greater than the current date');
        this.loading = false;
        return;

      }
    }


    if (this._Entity.Status == "Inactive") {
      if (!this._Entity.TerminationDate.jsdate) {
        this._Entity.TerminationDate = this._Entity.TerminationDate;
      }
      else {
        this._Entity.TerminationDate = formatDate(this._Entity.TerminationDate.jsdate);
      }

      var mTerDate = formatDate(this._Entity.TerminationDate).split("/");
      var _TerYear = mTerDate[0];
      var _TerMonth = mTerDate[1];
      var _TerDay = mTerDate[2];
      var mTerNewDate = _TerMonth + '/01/' + _TerYear;


      var _CurrDate = formatDate(new Date()).split("/");
      var _DateYear = _CurrDate[0];
      var _DateMonth = _CurrDate[1];

      var _finaldate = _DateMonth + '/01/' + _DateYear;


      if (new Date(mTerNewDate) < new Date(this.OrgStartDate)) {
        this.toastr.error("Termination month should be greater than the Organization start date");
        this.loading = false;
        return;
      }
      else if (new Date(mTerNewDate) < new Date(_finaldate)) {
        this.toastr.error("Termination Date month should be equal to or greater than Current Date month.");
        this.loading = false;
        return;
      }

      //else if (new Date(this.SubsMaxDate) < new Date()) {
      //  if(this.SubsMaxDate != null)
      //  {
      //    // if (this._Organization.TerminationDate < this._Organization.StartingDate) {
      //    this.toastr.error("Subscription Max Date Should be greater than Current Date.");
      //    this.loading = false;
      //    return;
      //  }
      //}


    }
    else {
      this._Entity.TerminationDate = "";
      this._Entity.TerminationNotes = "";
      this._Entity.ReasonForTermination = "";
    }

    if (this._Entity.FranchiseBrand != null) {
      if (this._Entity.FranchiseBrand.Name != undefined) {
        this._Entity.FranchiseBrand = this._Entity.FranchiseBrand.Name;
      }
      else {
        this._Entity.FranchiseBrand = this._Entity.FranchiseBrand;
      }
    }
    else {
      this._Entity.FranchiseBrand = this._Entity.FranchiseBrand;
    }
    if (this._Entity.HotelBrand != null) {
      if (this._Entity.HotelBrand.Name != undefined) {
        this._Entity.HotelBrand = this._Entity.HotelBrand.Name;
      }
      else {
        this._Entity.HotelBrand = this._Entity.HotelBrand;
      }
    }
    else {
      this._Entity.FranchiseBrand = this._Entity.FranchiseBrand;
    }

    //Dual PMS Validation on Entry Type
    if (this._Entity.DoubleEntrySystem == 'Single') {
      if (this._Entity.DualPMSSetting == true) {
        if (this._Entity.pmsMaster == 'FOSSE') {
          this.toastr.error("'FOSSE' can't be selected as dual PMS with 'Single' entry type.");
          this.loading = false;
          return;
        }
      }
    }
    if (this._Entity.DoubleEntrySystem == 'Double') {
      if (this._Entity.DualPMSSetting == true) {
        if (this._Entity.pmsMaster != 'FOSSE') {
          this.toastr.error("Only 'FOSSE' can be selected as dual PMS with 'Double' entry type");
          this.loading = false;
          return;
        }
      }
    }

    //Dual PMS
    if (this._Entity.DualPMSSetting == true) {
      if (this._Entity.pmsMaster == '') {
        this.toastr.error("Please select dual PMS type!.");
        this.loading = false;
        return;
      }
      if (this._Entity.PMSname !=null) {
        if (this._Entity.PMSname.indexOf(" ") >= 0) {
          this.toastr.error("Space(s) not allowed in pms name!.");
          this.loading = false;
          return;
        }
      }
    }

    //Epay
    if (this.EPayGrid != "undefined" || this.EPayGrid != undefined) {
      //Vaildation
      var Counter = 0;
      for (let i = 0; i < this.EPayGrid.length; i++) {
        if (this.EPayGrid[i].ePayCustID.length > 0) {
          Counter = Counter + 1;
        }
      }
      if (this._Entity.FeatureFlagEpay == true) {
        if (Counter == 0 && (this._Entity.EPaySetting == true)) {
          this.toastr.error("Please enter atleast 1 CustID to enable ePay.");
          this.loading = false;
          return;
        }
        if (Counter > 0 && (this._Entity.EPaySetting == false)) {
          this.toastr.error("Please remove all CustIDs to disable ePay.");
          this.loading = false;
          return;
        }
        //ENDS
        this.EPayGrid.forEach((element) => {
          let EpayCustId = element.ePayCustID;
          let OprId = element.oprID;

          if (EpayCustId != "undefined" && OprId != "undefined") {
            this._Subscription.SaveEPayAccount(this.QueryTenantID, this.QueryEntityID, EpayCustId, OprId).subscribe(res => {
              var data = res;
            });
          }
        });
      }
    }

    if (this._Entity.EPaySetting == true) {
      this._Entity.ePay = "1";
    }
    else {
      this._Entity.ePay = "0";
    }

    if (this._Entity.DualPMSSetting == true) {
      this._Entity.isDualPMS = "1";
      this._Subscription.SaveDualPMSSetting(this.QueryTenantID, this.QueryEntityID, this._Entity.pmsMaster, this._Entity.PMSname.trim(), this._Entity.isDualPMS).subscribe(res => {
        var data = res;
        if (data != null) {
          if (data[0].result =="EXISTS") {
            this.toastr.error("PMS Name already exists into our system, please enter some other name.");
            this.loading = false;
            return;
          }
        }
      });
    }
    else {
      this._Entity.isDualPMS = "0"
      this._Entity.pmsMaster = "";
      this._Entity.PMSname = "";
      debugger;
      this._Subscription.SaveDualPMSSetting(this.QueryTenantID, this.QueryEntityID, this._Entity.pmsMaster, this._Entity.PMSname, this._Entity.isDualPMS).subscribe(res => {
        var data = res;
        if (data != null) {
          if (data[0].result == "EXISTS") {
            this.toastr.error("PMS Name already mapped into our system, hence dual brand PMS can not be disabled.");
            this.loading = false;
            return;
          }
        }
      });
    }

    this._EntityService.SaveEntityDetails(this._Entity).subscribe(res => {
      var data = res;
      this.loading = false;

      if (data.message == "Record Saved Successfully" || data.message == "Updated Successfully") {
        this.toastr.success(data.message, ' EntityID:' + data.displayHotelid, {
          allowHtml: true
        });

        this.QueryEntityID = data.hotelid;
        this._Entity.EntityID = data.hotelid;
        this._Entity.DisplayHotelId = data.displayHotelid;
        this._Entity.FranchiseBrandID = data.franchiseBrandId;
        this._Entity.HotelBrandID = data.hotelBrandId;
        this._Entity.AddBrandId = data.addBrandId;
        this._Entity.HotelGroupID = data.hotelGroupId;
        this._Entity.SalesTaxId = data.salesTaxId;
        // this._Entity.PMS_SystemId = data.pms_SystemId;
        this._Entity.PMS_System = data.pms_System;
        this._Entity.AccountingId = data.accountingId;
        this._Entity.Labour_ManagementId = data.labour_ManagementId;
        this._Entity.PayrollId = data.payrollId;
        this._Entity.ProcurementId = data.procurementId;
        this._Entity.SalesId = data.salesId;
        this._Entity.Facilities_ManagementId = data.facilities_ManagementId;
        this.EntityStaus = this._Entity.Status;
        this.Alert = false;
        this.GetTableData();
        this.GetEntitychangeLog();
        this.GetHotelAccountcompleteData();
      }
      else {
        this.toastr.error(data.message);
        this.loading = false;
      }
    });
  }

  CheckExtender(Name: any, type: string) {

    if (Name.id == "" || Name.id == undefined) {
      if (Name == "") {
        if (type == '1') {
          this.CheckAppExt1 = type;
        }
        else if (type == '2') {
          this.CheckAppExt2 = type;
        }
        else if (type == '3') {
          this.CheckAppExt3 = type;
        }
        else if (type == '4') {
          this.CheckAppExt4 = type;
        }
        else if (type == '5') {
          this.CheckAppExt5 = type;
        }
        else if (type == '6') {
          this.CheckAppExt6 = type;
        }
        else if (type == '7') {
          this.CheckAppExt7 = type;
        }
      }
      else {
        if (type == '1') {
          this.CheckAppExt1 = "";
        }
        else if (type == '2') {
          this.CheckAppExt2 = "";
        }
        else if (type == '3') {
          this.CheckAppExt3 = "";
        }
        else if (type == '4') {
          this.CheckAppExt4 = "";
        }
        else if (type == '5') {
          this.CheckAppExt5 = "";
        }
        else if (type == '6') {
          this.CheckAppExt6 = "";
        }
        else if (type == '7') {
          this.CheckAppExt7 = "";
        }
      }
    }
    else {
      if (type == '1') {
        this.CheckAppExt1 = type;
      }
      else if (type == '2') {
        this.CheckAppExt2 = type;
      }
      else if (type == '3') {
        this.CheckAppExt3 = type;
      }
      else if (type == '4') {
        this.CheckAppExt4 = type;
      }
      else if (type == '5') {
        this.CheckAppExt5 = type;
      }
      else if (type == '6') {
        this.CheckAppExt6 = type;
      }
      else if (type == '7') {
        this.CheckAppExt7 = type;
      }
    }
  }

  CheckBrandExtender(Name: any, type: string) {

    this.BrandCheck = type;
    if (Name.Id == "" || Name.Id == undefined) {
      this.CheckAppExt = "true";
    }
    else {
      this.CheckAppExt = "false";
    }
  }


  HidePwdPopUp() {
    this.ModelAddBrand = "none";
  }
  HideEditPwdPopUp() {
    this.ModelEditBrand = "none";
  }

  Hidehotel() {
    this.modelHotal = "none";
  }
  EditHotel(Name: string, value: string, text: any) {
    this._Entity.Queryname = Name;
    this.Buttontext = "Update";
    this.QueryBrandValue = value;
    this.Sethotelheight = 323;
    this.btnfranchise = false;
    if (this._Entity.HotelBrand.Id != null || this._Entity.HotelBrand.Id != undefined) {
      this._Entity.HotelBrand = this._Entity.HotelBrand.Name;
    }
    else {
      this._Entity.HotelBrand = this._Entity.HotelBrand;
    }
    this.modelHotal = "block";
    if (text.Name != undefined) {
      this._Entity.HotelGroupID = text.Uniqueno;
      this._Entity.Intersectid = text.IntersectId;
    }
    this._Entity.FranchiseDD = this._Entity.FranchiseBrand;
    this._Entity.HotelBrandOther = this._Entity.HotelBrand;
    this.GetHotelEditBrand();
    this.GetHotelcompleteData();
    this.GetHotelAccountcompleteData();
  }

  CheckHotelStatus(text: any) {
    this.CheckHotelExt = "0";
    if (text.Id != undefined) {
      this.CheckHotelExt = text.name;
    }
    else {
      this.CheckHotelExt = "";
    }
  }

  public GetHotelEditBrand() {
    this._EntityService.GetFranDetails(this.QueryTenantID, this._Entity.HotelBrand).subscribe(res => {
      var data = res.json();
      this.GetFranchiseDD();
      if (data != null) {
       
        if (+data[0].id > 0) {
          this._Entity.FranchiseDD = data[0].name;
          this._Entity.AddBrandId = data[0].id;
        }
      }
    })
  };

  HideAppPopup() {
    this.ModelAddApp = "none";
    this.isValidFormAddAppSubmitted = false;
  }
  public RedirectOrganizationPage(TenantId: number) {
    localStorage.setItem('EntityID', this._Entity.EntityID);
    localStorage.setItem('OrganizationCode', this.QueryOrgcode);
    this.ParentPage = JSON.parse(atob(this.Activeroute.snapshot.params['pageName']));
    if (this.ParentPage == "Subscription") {
      this.router.navigate(['/OrganizationDetails', { TenantID: btoa(JSON.stringify(TenantId)), pageName: btoa(JSON.stringify('Subscription')) }]);
    }
    else if (this.ParentPage = "SubscriptionDetails") {
      this.router.navigate(['/OrganizationDetails', { TenantID: btoa(JSON.stringify(TenantId)), pageName: btoa(JSON.stringify('SubscriptionDetails')) }]);
    }
    else {
      this.router.navigate(['/OrganizationDetails', { TenantID: btoa(JSON.stringify(TenantId)), pageName: btoa(JSON.stringify('CreateEntity')) }]);
    }
  }

  SaveAppName(form: NgForm) {

    if (form.valid) {
      let data: any = {};
      this.loading = true;

      data.Type = this.QueryAppType;


      data.AppName = this._Entity.AddApp;
      data.Value = this.QueryAppValue;
      data.id = this._Entity.AddAppId;
      data.DoubleEntrySystem = this._Entity.DoubleEntrySystemEntry;


      if (this._Entity.AddApp.appName != undefined) {

        data.AppName = this._Entity.AddApp.appName;
      }
      this._EntityService.SaveAppName(data).subscribe(res => {

        var data = res;
        this.loading = false;
        if (data.message == "Record Saved Successfully" || data.message == "Updated Successfully") {
          this.toastr.success(data.message);
          this.ModelAddApp = "none";
          if (this.QueryAppType == '1') {
            this.CheckAppExt1 = "0";
          }
          else if (this.QueryAppType == '2') {
            this.CheckAppExt2 = "0";
          }
          else if (this.QueryAppType == '3') {
            this.CheckAppExt3 = "0";
          }
          else if (this.QueryAppType == '4') {
            this.CheckAppExt4 = "0";
          }
          else if (this.QueryAppType == '5') {
            this.CheckAppExt5 = "0";
          }
          else if (this.QueryAppType == '6') {
            this.CheckAppExt6 = "0";
          }
          else if (this.QueryAppType == '7') {
            this.CheckAppExt7 = "0";
          }
          if (data.type == "1") {
            this.CurrentAppName = "PMS Used";
            //if (this.checkAppStatus1 == "1") {
            if (this.QueryAppValue == "New" || this.checkAppStatus1 != "1") {
              //  // this._Entity.PMS_System = this._Entity.AddApp;
              this.getAllPMSSetting();
            }
            else {
              this.getAllPMSSetting();
            }
            //}
            //this._Entity.PMS_SystemId = this._Entity.AddAppId;
          }
          else if (data.type == "2") {
            this.CurrentAppName = "Accounting";
            //if (this.checkAppStatus2 == "2") {
            if (this.QueryAppValue == "New" || this.checkAppStatus2 != "2") {
              this._Entity.Accounting = this._Entity.AddApp;
            }
            //}
            //this._Entity.AccountingId = this._Entity.AddAppId;
          }
          else if (data.type == "3") {
            this.CurrentAppName = "Labor Management"
            //if (this.checkAppStatus3 == "3") {
            if (this.QueryAppValue == "New" || this.checkAppStatus3 != "3") {
              this._Entity.Labour_Management = this._Entity.AddApp;
            }
            //}
            //this._Entity.Labour_ManagementId = this._Entity.AddAppId;
          }
          else if (data.type == "4") {
            this.CurrentAppName = "Payroll"
            //if (this.checkAppStatus4 == "4" ) {
            if (this.QueryAppValue == "New" || this.checkAppStatus4 != "4") {
              this._Entity.Payroll = this._Entity.AddApp;
            }
            //}
            //this._Entity.PayrollId = this._Entity.AddAppId;
          }
          else if (data.type == "5") {
            this.CurrentAppName = "Procurement"
            // if (this.checkAppStatus5 == "5") {
            if (this.QueryAppValue == "New" || this.checkAppStatus5 != "5") {
              this._Entity.Procurement = this._Entity.AddApp;
            }
            //}
            //this._Entity.ProcurementId = this._Entity.AddAppId;
          }
          else if (data.type == "6") {
            this.CurrentAppName = "Sales"
            //if (this.checkAppStatus6 == "6") {
            if (this.QueryAppValue == "New" || this.checkAppStatus6 != "6") {
              this._Entity.Sales = this._Entity.AddApp;
            }
            //}
            //this._Entity.SalesId = this._Entity.AddAppId;
          }
          else if (data.type == "7") {
            this.CurrentAppName = "Facilities Management"
            //if (this.checkAppStatus7 == "7") {
            if (this.QueryAppValue == "New" || this.checkAppStatus7 != "7") {
              this._Entity.Facilities_Management = this._Entity.AddApp;
            }
            //}
            //this._Entity.Facilities_ManagementId = this._Entity.AddAppId;
          }
          if (data.type == "1" && data.value == "New") {
            this._Entity.PMS_System = data[0].appName;
            //this._Entity.PMS_System = data.a;
            //this.getAllPMSSetting();
          }
          else if (data.type == "1" && data.value == "Edit") {
            this._Entity.PMS_System = data.appName;
          }
          else if (data.type == "2" && data.value == "New") {
            this._Entity.AccountingId = data.id;
          }
          else if (data.type == "3" && data.value == "New") {
            this._Entity.Labour_ManagementId = data.id;
          }
          else if (data.type == "4" && data.value == "New") {
            this._Entity.PayrollId = data.id;
          }
          else if (data.type == "5" && data.value == "New") {
            this._Entity.ProcurementId = data.id;
          }
          else if (data.type == "6" && data.value == "New") {
            this._Entity.SalesId = data.id;
          }
          else if (data.type == "7" && data.value == "New") {
            this._Entity.Facilities_ManagementId = data.id;
          }
        }
        else {
          this.toastr.error(data.message);
          this.loading = false;

        }
      });
    }
    else {
      this.isValidFormAddAppSubmitted = true;
    }
  }


  public SaveBrandName(form: NgForm) {
    debugger;
    if (form.valid && (this.CheckHotelExt != '' || this._Entity.Queryname != "Hotel")) {
      let data: any = {};
      if (this._Entity.Queryname == "Hotel") {
        if (this._Entity.FranchiseDD == "-1") {
          this.toastr.error("Please Select atleast one Franchise Brand");
          return;
        }
      }
      if (this._Entity.Queryname == "Hotel" && this.QueryBrandValue == "New") {
        if (this._Entity.HotelBrandOther == "") {
          this.toastr.error("Please enter valid Hotel Brand");
          return;
        }
      }
      if (this._Entity.Queryname == "Franchise" && this.QueryBrandValue == "New") {
        data.AddBrand = this._Entity.AddBrand;
      }
      else if (this._Entity.Queryname == "Franchise" && this.QueryBrandValue == "Edit") {
        data.AddBrand = this._Entity.EditAddBrand;
      }

      data.Name = this._Entity.Queryname;
      data.value = this.QueryBrandValue;
      data.tenantId = this.QueryTenantID;

      if (data.value == "New") {
        data.id = 0;
      }
      else {
        data.id = Number(this._Entity.AddBrandId).toString();
      }
      data.hotelName = this._Entity.HotelBrandOther;
      data.FranchaiseDD = this._Entity.FranchiseDD;
      data.IntersectId = Number(this._Entity.Intersectid).toString();
      if (data.value == "Edit") {
        data.HotelBrandID = Number(this._Entity.HotelGroupID).toString();
      }
      this.btnfranchise = true;
      this._EntityService.SaveBrandName(data).subscribe(res => {
        var data = res;
        this.loading = false;

        //this.btnHotel = true;
        if (data.Message == "Record Saved Successfully" || data.Message == "Updated Successfully") {
          this.toastr.success(data.Message);
          this.ModelAddBrand = "none";
          this.ModelEditBrand = "none";
          if (this._Entity.Queryname == "Franchise") {
          /*  if (this.EditFranchiseDet == "") {*/
              this._Entity.AddBrandId = data.Id;
            /*}*/
          }
          if (this._Entity.Queryname == "Hotel") {
            if (this.EditHotelDet == "") {
              this._Entity.HotelGroupID = data.HotelBrandID;
            }
          }
          if (this.QueryBrandValue == "Edit" && this._Entity.Queryname == "Franchise") {
            /*if (this.EditFranchiseDet == "") {*/
              this._Entity.FranchiseBrand = this._Entity.EditAddBrand;
           /* }*/
          }
          if (this._Entity.Queryname == "Franchise" && this.QueryBrandValue == "New") {
            this._Entity.FranchiseBrand = this._Entity.AddBrand;
            this._Entity.HotelBrand = '';
            this._Entity.FranchiseDD = this._Entity.AddBrand;

          }
          if (this._Entity.Queryname == "Hotel") {
            this.modelHotal = "none";

            if (this.EditHotelDet == "") {
              this._Entity.HotelBrand = this._Entity.HotelBrandOther;
            }
            this._Entity.FranchiseBrand = this._Entity.FranchiseDD;
          }
          this.GetFranchiseDD();
        }
        else {
          this.toastr.error(data.Message);
          this.loading = false;

        }
      });
    }
    if (this._Entity.Queryname == "Hotel") {
      this.isValidFormHotel = true;
    }
    else if (this._Entity.Queryname == "Franchise") {
      this.isValidFormFranchise = true;
    }
  }

  public GetEntityDetails() {
    this.loading = true;

    this._EntityService.GetEditEntityDetails(this.QueryTenantID, this.QueryEntityID).subscribe(res => {

      var data = res;
      this._EntityService.GetEditAppDetails(this.QueryEntityID).subscribe(res1 => {
        var data1 = res1;
        this._Entity.PMS_System
        //this._Entity.PMS_System.appName;
        if (data1.length != 0) {
          this.getAllEntryTypeByPMSSetting(data1[0].appName);
        }

        this.EditEntityDet(data, data1);


      });

    });
    this.Setheight();
    this.loading = false;
  }

  public EditEntityDet(data: any, data1: any) {

    if (data[0].nonUs == 'No') {
      this._Entity.NonUS = false;
    }
    else {
      this._Entity.NonUS = true;
    }
    if (data[0].billByCc == 'Y') {
      this._Entity.BillByCC = true;
    }
    else {
      this._Entity.BillByCC = false;
    }
    this.TenantStatus = data[0].tenantStatus;
    this._Entity.TenantId = data[0].tenantId;
    this._Entity.city = data[0].city;
    this._Entity.AccountExecutive = parseInt(data[0].accountExecutive);

    // this._Entity.PMS_System = data1[0].appName;
    //data[0].accountExecutive.charAt(0).toLocaleUpperCase() + data[0].accountExecutive.substr(data[0].accountExecutive.indexOf('.') + 1).toLocaleUpperCase();
    //this._Entity.AccountExecutive = this._Entity.AccountExecutive.toUpperCase(); 
    this._Entity.Country = data[0].country;
    this._Entity.state = data[0].state;
    this._Entity.Province = data[0].province;
    this._Entity.AStreet = data[0].astreet;
    this._Entity.CCName = data[0].ccName;
    this._Entity.CCNumber = data[0].ccNumber;
    this._Entity.CCtype = data[0].ccType;
    this._Entity.CCZipCode = data[0].cczipcode;
    this._Entity.HolidayRate = data[0].holidayRate;
    this._Entity.DoubleOverTime = data[0].doubleOverTime;
    this._Entity.OverTime = data[0].overtime;
    this._Entity.IFGuru = data[0].ifguru;
    this._Entity.EntityCode = data[0].entityCode;
    this._Entity.Type = data[0].type;
    this._Entity.Entityname = data[0].pname;
    this._Entity.IFGuruEmail = data[0].ifguruEmail;
    this._Entity.IFGuruPhone = data[0].ifguruPhone;
    this._Entity.Legalname = data[0].legalName;
    this._Entity.OrganizationCode = this.QueryOrgcode;
    this._Entity.EntityID = data[0].hotelid;
    this._Entity.InnCode = data[0].innCode;
    this._Entity.FranchiseBrand = data[0].franchiseBrand;
    this._Entity.HotelBrand = data[0].hotelBrand;
    this._Entity.BillingFrequency = data[0].billingFrequency;
    this._Entity.Status = data[0].status;
    this._Entity.TaxID = data[0].taxId;
    this._Entity.HotelBrandID = data[0].hotelBrandId;
    this._Entity.FranchiseBrandID = data[0].franchiseBrandId;
    this._Entity.AddBrand = data[0].franchiseBrand;
    this._Entity.AddBrandId = data[0].franchisegroupId;
    this._Entity.HotelGroupID = data[0].hotelGroupId;
    this._Entity.SalesTax = data[0].salesTax;
    this._Entity.SalesTaxId = data[0].salesTaxID;
    this._Entity.TimeZone = data[0].timeZone;
    this._Entity.DisplayHotelId = data[0].displayHotelid;
    this._Entity.BankRoutingNumber = data[0].bankroutingnumber;
    this._Entity.Bankname = data[0].bankname;
    this._Entity.BankAccNumber = data[0].bankaccountnumber;
    this._Entity.Intersectid = data[0].intersectid;
    this._Entity.Phone = data[0].phone;
    this._Entity.DailyActivityId = data[0].dailyentryid;
    this.OrgStartDate = data[0].orgstartDate;
    this.SubsMaxDate = data[0].subsmaxDate;
    this.SubsStatus = data[0].subsStatus;
    this.prevTimeZone = data[0].timeZone;
    this._Entity.DigitalACS = data[0].digitalACS
    if (data[0].daylightSavings == 'No') {
      this._Entity.DayLightSavings = false;
    }
    else {
      this._Entity.DayLightSavings = true;
    }
    if (data[0].featureflag == 'YES') {
      this._Entity.FeatureFlagEpay = true;
    }
    else {
      this._Entity.FeatureFlagEpay = false;
    }
    if (data[0].ePaySetting == '1') {
      this._Entity.EPaySetting = true;
    }
    else {
      this._Entity.EPaySetting = false;
    }
    //DoubleEntrySystem
    //this._Entity.DoubleEntrySystemEntry = data[0].doubleentrysystem;


    //if (this._Entity.PMS_System == "") {
    //  this._Entity.DoubleEntrySystem = "Single";
    //} else {
    this._Entity.DoubleEntrySystem = data[0].doubleentrysystem;
    // }


    if (data[0].billByCc != 'Y') {
      this._Entity.ExpirationDate = "";
    }
    else {
      // NW-81482: the server returns expirationDate as a UTC-midnight ISO string.
      // new Date(isoString) parses that instant, and formatDate() (used later to
      // build/compare this value) reads it back with LOCAL getters - in any
      // timezone behind UTC that silently rolls the calendar date back by one day,
      // which can make a genuinely future CC Expiration Date compare as expired.
      // Rebuild the Date from the UTC calendar components so the local getters
      // return the same date the server stored.
      this._Entity.ExpirationDate = { jsdate: utcDateStringToLocalDate(data[0].expirationDate) };
    }
    if (data[0].reasonForTermination != null) {
      this._Entity.ReasonForTermination = data[0].reasonForTermination;
    }
    this.EntityStaus = data[0].status;
    if (data[0].status == "Inactive") {
      if (data[0].terminationDate == "null") {
        this._Entity.TerminationDate = "";
      }
      else {
        this._Entity.TerminationDate = { jsdate: new Date(data[0].terminationDate) };
      }
    }
    this._Entity.TerminationNotes = data[0].terminationNotes;
    this._Entity.ZipCode = data[0].zipCode;

    if (data[0].isDualPMS == '1') {
      this._Entity.DualPMSSetting = true;
     
    }
    else {
      this._Entity.DualPMSSetting = false;
    }
    this._Entity.pmsMaster = data[0].dualPMS;
    this._Entity.PMSname = data[0].pmsName;


    for (let i = 0; i <= data1.length - 1; i++) {
      if (data1[i].apptypeId == 1) {


        this._Entity.PMS_System = data1[i].appName;
        this._Entity.PMS_SystemId = data1[i].id;
      }

      if (data1[i].apptypeId == 2) {
        this._Entity.Accounting = data1[i].appName;
        //if (this._Entity.Accounting == "") {
        //  this.checkAppStatus2 = "2"
        //}
        this._Entity.AccountingId = data1[i].id;
      }
      if (data1[i].apptypeId == 3) {
        this._Entity.Labour_Management = data1[i].appName;
        //if (this._Entity.Labour_Management == "") {
        //  this.checkAppStatus3 = "3"
        //}
        this._Entity.Labour_ManagementId = data1[i].id;
      }
      if (data1[i].apptypeId == 4) {
        this._Entity.Payroll = data1[i].appName;
        //if (this._Entity.Payroll == "") {
        //  this.checkAppStatus4 = "4"
        //}
        this._Entity.PayrollId = data1[i].id;

      }
      if (data1[i].apptypeId == 5) {
        this._Entity.Procurement = data1[i].appName;
        //if (this._Entity.Procurement == "") {
        //  this.checkAppStatus5 = "5"
        //}
        this._Entity.ProcurementId = data1[i].id;
      }
      if (data1[i].apptypeId == 6) {
        this._Entity.Sales = data1[i].appName;
        //if (this._Entity.Sales == "") {
        //  this.checkAppStatus6 = "6"
        //}
        this._Entity.SalesId = data1[i].id;
      }
      if (data1[i].apptypeId == 7) {
        this._Entity.Facilities_Management = data1[i].appName;
        //if (this._Entity.Facilities_Management == "") {
        //  this.checkAppStatus7 = "7"
        //}
        this._Entity.Facilities_ManagementId = data1[i].id;
      }

    }
    this.Title = "Entity Details - " + this._Entity.EntityCode;
  }

  public StatusChange() {
    this._Status = true;
    this.Setheight();
    if (this._Entity.Status == "Inactive") {
      this._Entity.TerminationDate = "";
      this._Entity.TerminationNotes = "";
      this._Entity.ReasonForTermination = "";
    }
  }
  public ReasonForTermination() {
    this._RFT = true;
  }

  TimeZoneChange() {

    if (this._Entity.Type == "1") {
      if (this.prevTimeZone != this._Entity.TimeZone && this.prevTimeZone != null) {
        this.toastr.error('Scheduled Report Time is already set for this organization. It will reset to default timings 08:00 Hours.');
      }
    }
  }


  Setheight() {
    if (this.QueryTenantID == "-1") {
      if (this._Entity.Status == "Inactive") {
        this.innerWidth = 100;
      }
      else {
        this.innerWidth = 100;
      }
    }
    else {
      if (this._Entity.Status == "Inactive") {
        this.innerWidth = 100;
      }
      else {
        this.innerWidth = 100;
      }
    }

  }
  public GetTableData() {

    this._Subscription.GetSubSearchResult(this.QueryTenantID, this.QueryEntityID).subscribe(res => {
      var data = res;
      this.SearchResult = data;

    });
  }

  EditSubscriptionDetails(Module: string) {    
    this.router.navigate(['/SubscriptionDetails', {
      TenantID: btoa(JSON.stringify(this.QueryTenantID)), EntityID: btoa(JSON.stringify(this.QueryEntityID)), Module: btoa(JSON.stringify(Module)), OrganizationCode: btoa(JSON.stringify(this._Entity.OrganizationCode)), EntityCode: btoa(JSON.stringify(this._Entity.EntityCode)),
      pageName: btoa(JSON.stringify('CreateEntity'))
    }]);
  }

  AddNewSubscription() {
    this.router.navigate(['/SubscriptionDetails', {
      TenantID: btoa(JSON.stringify(this.QueryTenantID)), EntityID: btoa(JSON.stringify(this.QueryEntityID)), OrganizationCode: btoa(JSON.stringify(this._Entity.OrganizationCode)), EntityCode: btoa(JSON.stringify(this._Entity.EntityCode)),
      pageName: btoa(JSON.stringify('CreateEntity'))
    }]);
  }


  OpenTerminationModal() {
    this.modelTerminationDate = "block";
  }

  CloseTerminationDate() {
    this.modelTerminationDate = "none";
  }
}

function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('/');
}

// NW-81482: builds a Date from a UTC-midnight ISO string using its UTC calendar
// components, so that later local-getter reads (e.g. formatDate above) return the
// same calendar date the server stored, regardless of the browser's timezone offset.
function utcDateStringToLocalDate(isoDateString) {
  var utc = new Date(isoDateString);
  return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
}






// WEBPACK FOOTER //
// ./src/app/Entity/CreateEntity.component.ts